import React, { createContext, useContext, type ReactNode } from 'react';

import type { Config } from 'app/config';
import createAuthService from 'app/services/auth';
import createPasswordService from 'app/services/password';
import createCognitoService from 'app/services/cognito';

const createServices = (config: Config) => ({
  auth: createAuthService({
    clientId: config.REACT_APP_AUTH_CLIENT_ID,
    clientSecret: config.REACT_APP_AUTH_CLIENT_SECRET,
    url: config.REACT_APP_AUTH_URL,
  }),
  password: createPasswordService({
    url: config.REACT_APP_PASSWORD_URL,
  }),
  cognito: createCognitoService({
    url: config.REACT_APP_COGNITO_EXCHANGE_URL,
  }),
});

const context = createContext({} as ReturnType<typeof createServices>);
const { Provider } = context;

export const ServicesProvider = ({ children, config }: { children: ReactNode; config: Config }) => (
  <Provider value={createServices(config)}>{children}</Provider>
);

export default () => useContext(context);
